
export const agregarTableroBasket = (idPartido, codigoSolicitud) => {

    let objTablero = new tableroBasket({ cc: { id: idPartido, valor: codigoSolicitud} });

    return objTablero;
}

/* objeto Tablero Basket */
var tableroBasket =
function(value, isActive) {
    this._value = value;
    this._estaActivo = isActive || true;
    this._cambioEncuentro = false;
    this._cambioIncidencias = false;
    this._cambioExtras = false;
    this._cambioFormaciones = false;
    this._tieneTiempo = true;

    /* TAG A ACTUALIZAR */
    if (this._value.cc.hasOwnProperty('tipoTablero')) {
        this.TAG_RESULTADOS = this._value.cc.tipoTablero + "resultado";
        this.TAG_INCIDENCIA = this._value.cc.tipoTablero + "i";
        this.TAG_ESTADO = this._value.cc.tipoTablero + "estado";
        this.TAG_PERIODO = this._value.cc.tipoTablero + "periodo";
        this.TAG_TIEMPO = this._value.cc.tipoTablero + "tiempo";
        this.TAG_RESUMEN = this._value.cc.tipoTablero + "resumen";
    }
    else {
        this.TAG_RESULTADOS = "resultado";
        this.TAG_INCIDENCIA = "i";
        this.TAG_ESTADO = "estado";
        this.TAG_PERIODO = "periodo";
        this.TAG_TIEMPO = "tiempo";
        this.TAG_RESUMEN = "resumen";
    }

    /* ******************** */


    this.setValue = function(valorActualizado) {
        try {
            if (valorActualizado.hasOwnProperty('cc')) { this._value.cc = valorActualizado.cc };
            if (valorActualizado.hasOwnProperty('encuentro')) { this._value.encuentro = valorActualizado.encuentro; this._cambioEncuentro = true; } else { this._cambioEncuentro = false; };
            if (valorActualizado.hasOwnProperty('ins')) { this._value.ins = valorActualizado.ins; this._cambioIncidencias = true; } else { this._cambioIncidencias = false; };
            if (valorActualizado.hasOwnProperty('fors')) { this._value.fors = valorActualizado.fors; this._cambioFormaciones = true; } else { this._cambioFormaciones = false; };
            if (valorActualizado.hasOwnProperty('extras')) { this._value.tablero = valorActualizado.extras; this._cambioExtras = true; } else { this._cambioExtras = false; };
        }
        catch (err) {
            if (isDebugging) { showError('tableroBasket.setValue', err) };
        }
    }
    this.cambiarActivo = function(isActive) {
        try {
            this._estaActivo = isActive;
        }
        catch (err) {
            if (isDebugging) { showError('tableroBasket.estaActivo', err) };
        }
    }
    this.tieneTiempo = function() {
        return this._tieneTiempo;
    }

    this.estaActivo = function() {
        return this._estaActivo;
    }

    this.actualizarReloj = function() { 
    }

    this.actualizarResultado = function() {
        try {
            var local, visitante;
            if ((this._value.encuentro.local.id != undefined) && (this._value.encuentro.visitante.id)) {
                this.actualizarResultado90Minutos();
            }
        }
        catch (err) {
            if (isDebugging) { showError('tableroBasket.actualizarResultado', err) };
        }

    }

    this.actualizarResultado90Minutos = function() {
        var local = $("#" + this.TAG_RESULTADOS + this._value.encuentro.local.id);
        var visitante = $("#" + this.TAG_RESULTADOS + this._value.encuentro.visitante.id);

        if ((local.length) && (visitante.length)) {
            if (this._value.encuentro.estado == "1") {
                local.html("-");
                visitante.html("-");
            }
            else {
                local.html(this._value.encuentro.local.puntosTotales);
                visitante.html(this._value.encuentro.visitante.puntosTotales);

                if ((this._value.encuentro.local.puntosTotales == "") || (this._value.encuentro.local.puntosTotales == "NaN")) {
                    local.html("0");
                }

                if ((this._value.encuentro.visitante.puntosTotales == "") || (this._value.encuentro.visitante.puntosTotales == "NaN")) {
                    visitante.html("0");
                }
            }
        }
    }

    
    this.actualizarEstado = function() {
        try {
            var estado;
            if (this._value.encuentro.estado != undefined) {
                estado = $("#" + this.TAG_ESTADO + this._value.cc.id);
                if (this._value.encuentro.estado != '2') {
                    estado.show();
                    $("#" + this.TAG_PERIODO + this._value.cc.id).hide();
                }
                if (estado.length) {
                    switch (this._value.encuentro.estado) {
                        case "1":
                            estado.html(this.ESTADO_SIN_COMIENZO);
                            break;
                        case "2":
                            estado.html(this.ESTADO_EN_JUEGO);
                            break;
                        case "3":
                            estado.html(this.ESTADO_FINALIZADO);
                            this._estaActivo = false;
                            break;
                        case "4":
                            estado.html(this.ESTADO_SUSPENDIDO);
                            break;
                        case "5":
                            estado.html(this.ESTADO_ENTRETIEMPO);
                            break;
                    }
                }
            }
        }
        catch (err) {
            if (isDebugging) { showError('tableroBasket.actualizarEstado', err) };
        }

    }
    this.actualizarPeriodo = function() {
        try {
            if (this._value.encuentro.tiempo != undefined) {
                var oPeriodo = $("#" + this.TAG_PERIODO + this._value.cc.id);
                if (oPeriodo.length) {
                    if (this._value.encuentro.estado == "2") {
                        oPeriodo.html("");
                        switch (this._value.encuentro.tiempo) {
                            case "8":
                                oPeriodo.html(this.TIEMPO_UNICO);
                                break;
                            case "17":
                                oPeriodo.html(this.PRIMER_CUARTO);
                                break;
                            case "18":
                                oPeriodo.html(this.SEGUNDO_CUARTO);
                                break;
                            case "19":
                                oPeriodo.html(this.TERCER_CUARTO);
                                break;
                            case "20":
                                oPeriodo.html(this.CUARTO_CUARTO);
                                break;
                            case "21":
                                oPeriodo.html(this.TIEMPO_SUPLEMENTARIO);
                                break;
                        }
                        $("#" + this.TAG_ESTADO + this._value.cc.id).hide();
                    }
                    else {
                        switch (this._value.encuentro.estado) {
                            case "1":
                                oPeriodo.html(this.ESTADO_SIN_COMIENZO);
                                break;
                            case "3":
                                oPeriodo.html(this.ESTADO_FINALIZADO);
                                break;
                            case "4":
                                oPeriodo.html(this.ESTADO_SUSPENDIDO);
                                break;
                            case "5":
                                oPeriodo.html(this.ESTADO_ENTRETIEMPO);
                                break;
                        }
                    }
                }
            }

        }
        catch (err) {
            if (isDebugging) { showError('tableroBasket.actualizarPeriodo', err) };
        }

    }

    this.actualizarIncidencia = function() {
        try {
            if (this._value.ins[0].inc.id != undefined) {
                var oIncidencia = $("#" + this.TAG_INCIDENCIA + this._value.cc.id);
                if (oIncidencia.length) {
                    var clase = "";
                    switch (this._value.ins[0].inc.tp.toLowerCase()) {
                        case "amarilla":
                            clase = "amarilla";
                            break;
                        case "roja":
                            clase = "roja";
                            break;
                        case "gol":
                            clase = "gol";
                            break;
                        case "cambio":
                            clase = "cambio";
                            break;
                        case "lesion":
                            clase = "lesion";
                        default:
                            clase = "fallo";
                            break;
                    }
                    oTextoIncidencia = $("#textoIncidencia", oIncidencia);
                    oTextoIncidencia.html(this._value.ins[0].inc.cm);
                    oIncidencia.addClass(clase).slideDown('slow').delay(7000).hide('fast', function() { $(this).removeClass(clase); });
                }
            }
        }
        catch (err) {
            if (isDebugging) { showError('tableroBasket.actualizarIncidencia', err) };
        }
    }

    this.isTypeOf = function(value) {
        var _isTypeOf = false;
        if (value == "tableroBasket")
            _isTypeOf = !_isTypeOf;
        return _isTypeOf;
    }

    this.actualizarExtras = function () {
        var marquesina;
        try {
            if (this._value.tablero.mq.texto != undefined && this._value.tablero.mq.texto != '' && this._value.tablero.mq.texto != null) {
                $("#marquesina" + this._value.cc.id).html("");
                $("#marquesina" + this._value.cc.id).append(this._value.tablero.mq.texto);
            }
        }
        catch (err) {
            if (isDebugging) { showError('tableroFutbol.actualizarEstado', err) };
        }

    }
    this.PRIMER_TIEMPO = "1er tiempo";
    this.SEGUNDO_TIEMPO = "2do tiempo";
    this.PRIMER_TIEMPO_SUPLEMENTARIO = "1er Supl.";
    this.SEGUNDO_TIEMPO_SUPLEMENTARIO = "2do Supl.";
    this.ESTADO_SIN_COMIENZO = "Sin comienzo";
    this.ESTADO_EN_JUEGO = "En juego";
    this.ESTADO_FINALIZADO = "Finalizado";
    this.ESTADO_SUSPENDIDO = "Suspendido";
    this.ESTADO_ENTRETIEMPO = "Entretiempo";

    this.TIEMPO_UNICO = "En Juego";
    this.PRIMER_CUARTO = "1er. Cuarto";
    this.SEGUNDO_CUARTO = "2do. Cuarto";
    this.TERCER_CUARTO = "3er. Cuarto";
    this.CUARTO_CUARTO = "4to. Cuarto";
    this.TIEMPO_SUPLEMENTARIO = "Suplementario";


    // implementa diferente para cada tipo de tablero: tennis, futbol
    this.execute = function() {
        try {
            if (this._cambioEncuentro) {
                this.actualizarEstado();
                this.actualizarPeriodo();
                this.actualizarResultado();
                this.actualizarExtras();
            }
            this.actualizarIncidencia();
        }
        catch (err) {
            if (isDebugging) { showError('tableroBasket.execute', err) };
        }
    }
};


// WEBPACK FOOTER //
// ./Statics/scripts/common/tableros/tableroBasket.js